import instance from '..';

export default class TimezoneAPI {
  static async getTimezoneList(token) {
    return instance.get('/api/tz_list/', { headers: { Authorization: `Token ${token}` } });
  }
}
